import { getApiBaseUrl } from '../config/api';

// FEAT-039 — Trust indicator badges client.
// Backs the CaregiverBadgeRow component on profile + discovery surfaces.
// Public-vs-authenticated filtering is enforced server-side; this client
// just forwards the optional auth token when available.

export type BadgeType =
  | 'VERIFIED'
  | 'SPECIALTY'
  | 'CAREVA_COMPLETION_CREDENTIAL'
  | 'STATE_CERTIFIED'
  | 'SPECIALTY_CREDENTIALED'
  | 'STATE_AGENCY_REGISTERED';

export interface BadgeMetadata {
  label?: string;
  specialtyName?: string;
  stateCode?: string;
  sourceCredentialIds?: string[];
}

export interface CaregiverBadge {
  id: string;
  type: BadgeType;
  grantedAt: string;
  expiresAt: string | null;
  metadata: BadgeMetadata;
}

export interface ListBadgesResponse {
  badges: CaregiverBadge[];
  viewer: { authenticated: boolean };
}

class BadgeService {
  async listForCaregiver(caregiverId: string): Promise<ListBadgesResponse> {
    const baseUrl = await getApiBaseUrl();
    const token = localStorage.getItem('authToken');
    const headers: HeadersInit = token
      ? { Authorization: `Bearer ${token}` }
      : {};
    const response = await fetch(`${baseUrl}/caregivers/${caregiverId}/badges`, {
      headers,
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.error?.message || 'Failed to load badges');
    }
    return response.json();
  }
}

export const badgeService = new BadgeService();
